export const billing = {
  BudgetSummaryReport: {
    mandatory: [
      'Date',
      'AccountNumber',
      'AccountName',
      'CampaignName',
      'CurrencyCode',
      'MonthlyBudget',
      'DailySpend',
      'MonthToDateSpend',
    ],
    default: [
      'Date',
      'AccountNumber',
      'AccountName',
      'CampaignName',
      'CurrencyCode',
      'ProductName',
      'MonthlyBudget',
      'DailySpend',
      'MonthToDateSpend',
    ],
  },
  CustomerInvoiceReport: {
    default: [
      'CustomerName',
      'PricingMethod',
      'SalesHouse',
      'SoldToCountry',
      'SoldToCustomerName',
      'CurrencyCode',
      'BilledAmount',
      'BilledAmountUSD',
      'BillToCountry',
      'BillToCustomerNumber',
      'BillToCustomerName',
      'Clicks',
      'DocumentNumber',
      'DocumentType',
      'NetRevenue',
      'NetRevenueUSD',
    ],
    mandatory: [
      'Month',
      'Clicks',
    ],
  },
  BillingStatementReport: {
    default: [
      'CustomerName',
      'AccountNumber',
      'CampaignName',
      'BillToCountry',
      'BillToCustomerNumber',
      'SoldToCustomerNumber',
      'BillToCustomerName',
      'DocumentNumber',
      'DocumentType',
      'BillingType',
      'NetAmountDue',
    ],
    mandatory: [
      'Month',
      'CustomerName',
      'AccountNumber',
      'BillToCountry',
      'BillToCustomerName',
      'DocumentNumber',
      'DocumentType',
      'NetAmountDue',
    ],
  },
  InsertionOrderReport: {
    default: [
      'IOReportMonth',
      'AccountName',
      'AccountNumber',
      'BillToCustomerName',
      'BillToCustomerNumber',
      'InsertionOrderDetails',
      'ChangeType',
      'ChangeAmount',
      'RemainingIOBudget',
      'CurrencyCode',
      'BillingDocumentNumber',
      'InsertionOrderId',
      'AccountId',
      'BDAmount',
      'MismatchedAmount',
      'MismatchedReason',
      'BudgetChangedAmount',
      'SpendAmount',
      'AdjustmentAmount',
      'BudgetChangeOldValue',
      'BudgetChangeNewValue',
    ],
    mandatory: [
      'ChangeType',
      'ChangeAmount',
      'InsertionOrderDetails',
    ],
  },
};
